import { render, staticRenderFns } from "./bday.vue?vue&type=template&id=06ced8bc&scoped=true"
import script from "./bday.vue?vue&type=script&lang=js"
export * from "./bday.vue?vue&type=script&lang=js"
import style0 from "./bday.vue?vue&type=style&index=0&id=06ced8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ced8bc",
  null
  
)

export default component.exports